export default "__VITE_ASSET__d1cc57b4__"